import { render, staticRenderFns } from "./MsisdnForm.vue?vue&type=template&id=b54d6f58&scoped=true&"
import script from "./MsisdnForm.vue?vue&type=script&lang=js&"
export * from "./MsisdnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54d6f58",
  null
  
)

export default component.exports